import dayjs from 'dayjs';
import React, { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createSelector } from 'reselect';
import { setMessageVisible } from '../../../actions/layout';
import { logging, logPostInfo } from '../../../actions/log';
import { resetMessageList, setMessageZan } from '../../../actions/message';
import { CONTEXT, MICROCONTEXT } from '../../../config';
import avatarV from '../../../static/f_user_v.png';
import UserHeader from '../../../static/forum_default_header.svg';
import Comment from './CommentReview';
import styles from './MessageLine.module.less';
import { useAliveController } from 'react-activation';

const actionMap = {
  // 这个要看下面type类型的
  1: '点赞',
  2: '收藏',
  3: '评论',

  // 这个动作是评论相关的
  4: '点赞',
  5: '回复',
};
const typeMap = {
  1: '应用',
  2: '专题',
  3: '帖子',
  4: '评论', // 方便前端显示
  5: '评论', // 方便前端显示
};
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(
  ({ message = {}, isComment = true, setCommentIndexCallback, orderIndex, commentIndex }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const logInfoData = useSelector(selectLogInfo);
    const { dropScope } = useAliveController();
    const handleComment = useCallback(() => {
      if (commentIndex !== orderIndex) {
        // 打开
        // eslint-disable-next-line no-unused-expressions
        setCommentIndexCallback && setCommentIndexCallback(orderIndex);
      } else {
        // 关闭
        // eslint-disable-next-line no-unused-expressions
        setCommentIndexCallback && setCommentIndexCallback(-1);
      }
    }, [commentIndex, orderIndex, setCommentIndexCallback]);

    const handleSkip = () => {
      dispatch(
        logging({
          category: 'C',
          action: 'Message_Forum',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            id: message.bizId,
            type: message.type,
          },
        }),
      );
      // dispatch(
      //   logPostInfo({
      //     source_p: logInfoData.source,
      //     source_pp: logInfoData.source_p,
      //   }),
      // );
      dispatch(setMessageVisible(false));
      dispatch(resetMessageList());
      switch (message.type) {
        case '1':
          history.push(
            message.androidType === '1'
              ? `${CONTEXT}/adetail/${message.bizId || ''}/-1/${message.bizInfo || '{}'}`
              : `${CONTEXT}/detail/soft/${message.bizId || ''}/${message.bizInfo || '{}'}`,
          );
          break;
        case '2':
          if (history?.pathname?.indexOf(`${CONTEXT}/special`) < 0) {
            dropScope('special');
          }
          const timer = setTimeout(() => {
            history.push(`${CONTEXT}/special?ztId=${message.bizId}`);
            clearTimeout(timer);
          }, 50);

          break;
        case '3':
          history.push(
            `${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/forumdetail?id=${message.bizId}&source=msg`,
          );
          break;
        default:
          break;
      }
    };

    const handleZan = () => {
      dispatch(
        setMessageZan({
          originalCommentId: message.originalCommentId,
          type: message.type,
          commentUserId: message.userId,
          bizId: message.bizId,
          tab: isComment ? 'comment' : 'collect',
          id: message.id,
        }),
      );
      dispatch(
        logging({
          category: 'C',
          action: 'Detail_CommmentZan',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            id: message.bizId,
            commmentId: message.originalCommentId,
            type: message.type,
          },
        }),
      );
    };
    return (
      <>
        <div className={styles.messageLine}>
          <div className={styles.user_avatar_box}>
            <img src={message.userHead || UserHeader} alt="" className={styles.user_image} />
            {message.isV === 1 && <img src={avatarV} className={styles.user_avatar_v} />}
          </div>
          <div className={styles.message_info}>
            <div className={styles.message_action}>
              <div className={styles.message_info}>
                <div className={styles.message_user}>{message.userNickname || '商店用户'}</div>
                <div className={styles.message_action_detail}>{actionMap[message.optType]}了</div>
                <div className={styles.message_action_content}>{`你的${((message.optType === '4' ||
                  message.optType === '5') &&
                  typeMap[message.optType]) ||
                  typeMap[message.type]}`}</div>
              </div>
              <div className={styles.message_action_time}>
                {message.createTime ? dayjs(message.createTime).format('YYYY-MM-DD HH:mm') : ''}
              </div>
            </div>
            {isComment && message.content && (
              <div className={styles.message_target_content}>
                {message.commentId !== message.originalCommentId &&
                message.content.indexOf('@') === 0
                  ? message.content.split(':')[1]
                  : message.content}
              </div>
            )}
            <div className={styles.message_content} onClick={handleSkip}>
              {message.targetContent && (
                <div className={styles.message_content_comment}>
                  <div className={styles.message_content_comment_detail}>
                    我：
                    {message.parentId !== message.originalCommentId &&
                    message.targetContent.indexOf('@') === 0
                      ? message.targetContent.split(':')[1]
                      : message.targetContent}
                  </div>
                </div>
              )}
              <div className={styles.message_content_title}>
                <div className={styles.message_content_title_type}>{typeMap[message.type]}</div>
                <div className={styles.message_content_title_content}>{message.bizName}</div>
              </div>
            </div>
            {isComment && (
              <>
                <div className={styles.message_reply}>
                  <div className={styles.message_reply_text} onClick={handleComment}>
                    <i className={`iconfont icon-msg_reply ${styles.message_reply_icon}`} />
                    {commentIndex === orderIndex ? '收起' : '回复'}
                  </div>

                  {message.type === '3' && message.optType === '3' && (
                    <div className={styles.message_reply_text} onClick={handleZan}>
                      <i
                        className={`iconfont ${
                          message.hasZan ? 'icon-msg_zaned' : 'icon-msg_zan'
                        } ${styles.message_reply_icon}`}
                      />
                      点赞
                    </div>
                  )}
                </div>

                <div className={styles.message_publish}>
                  {commentIndex === orderIndex && (
                    <Comment
                      comment={message}
                      publishCallback={handleComment}
                      logInfo={{ source: 'Message' }}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </>
    );
  },
);
